"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lcHttp = _interopRequireDefault(require("lc-http"));
require("./index.scss");
var Shapes = _interopRequireWildcard(require("./shapes"));
var _Offers = _interopRequireDefault(require("./offer/Offers"));
var _Button = _interopRequireDefault(require("./button/Button"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var NO_INTEREST_PRODUCT = 'INTEREST_FREE_LOAN';
var PROMOTIONAL_RATE_PLAN_PRODUCT = 'PROMOTIONAL_RATE_PLAN';
var disclosureIndices = {
  PAYMENT_DETAIL_NO_INTEREST_PLAN: 1,
  NO_INTEREST_PLAN: 2,
  PAYMENT_DETAIL_PROMOTIONAL_RATE_PLAN: 3,
  PROMOTIONAL_RATE_PLAN: 4
};
var filterByProductTypeAndSortByTerm = function filterByProductTypeAndSortByTerm(collection, filterByProduct) {
  return collection.filter(function (_ref) {
    var productType = _ref.productType;
    return productType === filterByProduct;
  }).sort(function (_ref2, _ref3) {
    var productTermA = _ref2.productTerm;
    var productTermB = _ref3.productTerm;
    return productTermA - productTermB;
  });
};
var ProductPanel = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(ProductPanel, _React$Component);
  var _super = _createSuper(ProductPanel);
  function ProductPanel() {
    var _this;
    (0, _classCallCheck2.default)(this, ProductPanel);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      selectedRadio: null,
      offerSelected: null
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "radioChange", function (e) {
      _this.setState({
        offerSelected: e.target.value,
        selectedRadio: e.target.attributes
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getRate", function (loanType) {
      if (loanType === 'prp') {
        return _this.props.subMarket.toLowerCase() === 'yts' ? 0.179 : 17.9;
      }
      return 0;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "buttonEvent", function (e) {
      var additionalTransactionUrl = _this.props.additionalTransactionUrl;
      var that = (0, _assertThisInitialized2.default)(_this);
      (0, _lcHttp.default)({
        method: 'post',
        url: additionalTransactionUrl,
        data: {
          loanAmount: parseInt(_this.state.selectedRadio.loanAmount.value, 10),
          applicationId: _this.props.applicationId,
          introTerm: parseInt(_this.state.selectedRadio.term.value, 10),
          rate: _this.getRate(_this.state.selectedRadio.loanType.value),
          productType: _this.state.selectedRadio.loanType.value
        }
      }).then(function () {
        var message = {
          message: 'Additional transaction was processed successfully.'
        };
        that.props.subMarket.toLowerCase() === 'lcps' ? that.props.onSuccess.handleAdditionalTransactionClose('APPROVED') : that.props.onSuccess(message);
      }).catch(function (response) {
        that.props.subMarket.toLowerCase() === 'lcps' ? that.props.onSuccess.handleAdditionalTransactionClose(false) : that.props.onError('Unable to complete transaction.');
        console.log(response);
      });
    });
    return _this;
  }
  (0, _createClass2.default)(ProductPanel, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        products = _this$props.products,
        constants = _this$props.constants;
      var ifProducts = filterByProductTypeAndSortByTerm(products, NO_INTEREST_PRODUCT);
      var prpProducts = filterByProductTypeAndSortByTerm(products, PROMOTIONAL_RATE_PLAN_PRODUCT);
      var colCounts = 'col-md-' + (ifProducts.length && prpProducts.length ? '6' : '12');
      return /*#__PURE__*/_react.default.createElement("div", null, this.props.products && this.props.products.length ? /*#__PURE__*/_react.default.createElement("div", {
        className: "additional-transaction-main-content col-md-12"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "product-revolving-container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "product-revolving-container__text"
      }, "Revolving lines of credit"), "with Comenity Capital Bank"), ifProducts && ifProducts.length ? /*#__PURE__*/_react.default.createElement("div", {
        className: colCounts
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "card-container-primary desktop-columns-6"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "card-heading"
      }, /*#__PURE__*/_react.default.createElement("span", null, constants.INTEREST_FREE_LOAN.pluralName, /*#__PURE__*/_react.default.createElement("sup", {
        className: "disclosure"
      }, disclosureIndices.NO_INTEREST_PLAN))), /*#__PURE__*/_react.default.createElement("div", {
        className: "card-body"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "card-metrics"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "card-description"
      }, "No Interest for 6 or 12 mo -", /*#__PURE__*/_react.default.createElement("br", null), " after that, 26.99% standard APR")), /*#__PURE__*/_react.default.createElement("div", {
        className: "card-offers"
      }, /*#__PURE__*/_react.default.createElement(_Offers.default, {
        offers: ifProducts,
        productType: "if",
        selectedRadio: this.radioChange,
        offerSelected: this.state.offerSelected,
        moPaymentDisclosure: disclosureIndices.PAYMENT_DETAIL_NO_INTEREST_PLAN,
        maxAllowed: this.props.maxAllowed,
        inValidInput: this.props.inValidInput
      }))))) : null, prpProducts && prpProducts.length ? /*#__PURE__*/_react.default.createElement("div", {
        className: colCounts
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "card-container-primary desktop-columns-6"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "card-heading"
      }, /*#__PURE__*/_react.default.createElement("span", null, constants.PROMOTIONAL_RATE_LOAN.pluralName, /*#__PURE__*/_react.default.createElement("sup", {
        className: "disclosure"
      }, disclosureIndices.PROMOTIONAL_RATE_PLAN))), /*#__PURE__*/_react.default.createElement("div", {
        className: "card-body"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "card-metrics"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "card-description"
      }, "17.90% APR for 24, 36, 48, or 60 mo -", /*#__PURE__*/_react.default.createElement("br", null), " after that, 26.99% standard APR")), /*#__PURE__*/_react.default.createElement("div", {
        className: "card-offers"
      }, /*#__PURE__*/_react.default.createElement(_Offers.default, {
        offers: prpProducts,
        productType: "prp",
        selectedRadio: this.radioChange,
        offerSelected: this.state.offerSelected,
        moPaymentDisclosure: disclosureIndices.PAYMENT_DETAIL_PROMOTIONAL_RATE_PLAN,
        maxAllowed: this.props.maxAllowed,
        inValidInput: this.props.inValidInput
      }))))) : null, /*#__PURE__*/_react.default.createElement(_Button.default, {
        offerSelected: this.state.offerSelected,
        buttonAction: this.buttonEvent
      }))) : null);
    }
  }]);
  return ProductPanel;
}(_react.default.Component);
ProductPanel.defaultProps = {
  radioChange: null,
  buttonEvent: null
};
ProductPanel.propTypes = {
  products: _propTypes.default.arrayOf(Shapes.Product),
  selectedRadio: _propTypes.default.arrayOf(Shapes.ProductSelected),
  buttonAction: _propTypes.default.bool,
  applicationId: _propTypes.default.string,
  additionalTransactionUrl: _propTypes.default.string,
  inValidInput: _propTypes.default.bool,
  maxAllowed: _propTypes.default.string,
  subMarket: _propTypes.default.string,
  constants: _propTypes.default.object
};
var _default = ProductPanel;
exports.default = _default;
